import React from 'react'
import { useMutation } from '@apollo/client'
import NewsLetterUI, { Props } from '@interflora/ui-components/build/components/NewsLatter/NewsLetter'
import { populateTemplateValues } from 'utils/components'
import { HandleSubmit, NewsletterSignUpValues } from '@interflora/ui-components/build/common/props'
import { NEWSLETTER_SIGNUP } from '../../graphql/queries'
import { useLoaded } from '@interflora/ui-components/build/components/MainContent/useComponentLoading'
import { useAnalytics } from 'hooks/useAnalytics'

export type NewsLetterProps = Omit<Props, 'signUp' | 'newsletterSignUp'> & {
  newsLetterSignUpButton: Props['newsletterSignUp']
}
export const updateNewsLetterSignUpTemplate: NewsletterSignUpValues = {
  firstName: '',
  lastName: '',
  email: '',
}
export const getNewsLetterSignUpHandler =
  (signUpMutation: any, updateNewsLetterSignUpTemplate: NewsletterSignUpValues): HandleSubmit<NewsletterSignUpValues> =>
  async (values) => {
    const signUpValues = { ...values, email: values.email.trim() }
    const signUpNewsletterValues = populateTemplateValues(signUpValues, updateNewsLetterSignUpTemplate)
    await signUpMutation({ variables: { input: signUpNewsletterValues } })
  }

const NewsLetter = (props: NewsLetterProps) => {
  const [signUpMutation] = useMutation(NEWSLETTER_SIGNUP)
  const analytics = useAnalytics()
  const { newsLetterSignUpButton, ...others } = props
  useLoaded(props)

  const signUp = getNewsLetterSignUpHandler(signUpMutation, updateNewsLetterSignUpTemplate)
  const newsLetterSignUpOpenAnalytics = () => analytics.newsLetterSignUpOpen('banner')

  const handleSignUp: HandleSubmit<NewsletterSignUpValues> = async (values) => {
    await signUp(values)
    analytics.newsLetterSignUpSubmit('banner')
  }

  return (
    <NewsLetterUI
      signUp={handleSignUp}
      newsletterSignUp={newsLetterSignUpButton}
      newsLetterSignUpOpenAnalytics={newsLetterSignUpOpenAnalytics}
      {...others}
    />
  )
}

export default NewsLetter
